import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import AddAdvancePayment from "./AddAdvancePayment";
import { loadAdvancePaymentsById } from "../../redux/rtk/features/advancePayment/advancePaymentSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import "./AdvancePayment.css";

const AdvancePayment = () => {
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const [applyModalOpen, setApplyModalOpen] = useState(false);
	const employeeId = getUserFromToken();

	useEffect(() => {
		if (isLogged && employeeId) {
			dispatch(loadAdvancePaymentsById(employeeId));
		}
	}, [dispatch, isLogged, employeeId]);

	if (!isLogged) {
		return <Navigate to="/admin/auth/login" replace />;
	}

	return (
		<div className="advance-payment-page-container">
			<div className="flex justify-between items-center mb-4">
				<h2 className="advance-payment-page-title">Advance Payment</h2>
				<Button
					type="primary"
					className="advance-payment-apply-btn"
					onClick={() => setApplyModalOpen(true)}
				>
					Apply for Advance Payment
				</Button>
			</div>

			<AddAdvancePayment
				tableOnly
				listSource="self"
				employeeId={employeeId}
				showApprovalActions={false}
			/>

			<Modal
				title="Apply for Advance Payment"
				open={applyModalOpen}
				onCancel={() => setApplyModalOpen(false)}
				footer={null}
				width={640}
				destroyOnClose
			>
				<AddAdvancePayment
					formOnly
					listSource="self"
					employeeId={employeeId}
					showApprovalActions={false}
					onCancel={() => setApplyModalOpen(false)}
					onSuccess={() => dispatch(loadAdvancePaymentsById(employeeId))}
				/>
			</Modal>
		</div>
	);
};

export default AdvancePayment;
